import React, { FC, useCallback } from 'react';

import { Icon } from '@rbilabs/components-library/build/components/icon';
import styled from 'styled-components';

import { ActionButton, ActionButtonVariants } from 'components/action-button';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';
import { useOrderContext } from 'state/order';
import { useStoreContext } from 'state/store';
import { primitive } from 'styles/constants/primitives';

const ClearStoreSMButtonWrapper = styled.div`
  position: absolute;
  inset-inline-start: ${primitive.$spacing2};
`;

export const ClearStoreSmButton: FC = () => {
  const renderButton = useFlag(LaunchDarklyFlag.ENABLE_LOCATOR_CLEAR_STORE_AND_SM_BUTTON);
  const { clearServerOrder } = useOrderContext();
  const { resetStore } = useStoreContext();

  const handleClick = useCallback(() => {
    clearServerOrder();
    resetStore();
  }, [clearServerOrder, resetStore]);

  const CLEAR_BUTTON_ICON = 'gear';

  if (!renderButton) {
    return null;
  }

  return (
    <ClearStoreSMButtonWrapper>
      <ActionButton
        variant={ActionButtonVariants.PRIMARY}
        color="text-button-reversed"
        endIcon={<Icon icon={CLEAR_BUTTON_ICON} color="primary" aria-hidden />}
        onClick={handleClick}
        data-testid="clear-store-sm-button"
        skipLogEvent
        onlyIcon
      />
    </ClearStoreSMButtonWrapper>
  );
};
